<template>
  <GButton
    class="invisible-captcha-btn"
    :type="type"
    @click="click"
    :disabled="disabled || !loaded"
    v-bind="$attrs"
  >
    <span
      :id="recaptchaId"
      data-size="invisible"
    />
    <GSpinner
      variant="small"
      v-if="!loaded"
    />
    <slot v-else />
  </GButton>
</template>

<script>
import GSpinner from '@trendyol-js/grace/core/GSpinner';
import GButton from '@trendyol-js/grace/core/GButton';
export default {

  components: {
    GSpinner,
    GButton,
  },

  props: {
    type: {
      type: String,
      default: 'submit',
    },

    siteKey: {
      type: String,
      required: true,
    },

    validate: {
      type: Function,
      default: () => Promise.resolve(true),
    },

    badge: {
      type: String,
      required: false,
      default: 'bottomright',
    },

    id: {
      type: String,
      required: false,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      widgetId: false,
      loaded: false,
    };
  },

  methods: {
    render () {
      this.widgetId = window.grecaptcha.render(this.recaptchaId, {
        sitekey: this.siteKey,
        size: 'invisible',
        badge: this.badge,
        callback: token => {
          this.$emit('callback', token);
          window.grecaptcha.reset(this.widgetId);
        },
      });
      this.loaded = true;
    },

    async click () {
      const isValid = await this.validate();

      isValid && window.grecaptcha.execute();
    },

    injectScript (isRetried = false) {
      const script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=tr';
      script.async = true;
      script.defer = true;
      script.onerror = () => {
        if (isRetried) {
          return this.$gtm.trackEvent({
            event: 'GAEvent',
            eventCategory: 'Onboarding - Seller Account UI',
            eventAction: 'InvisibleRecaptcha Retry Failed',
            eventLabel: '',
          });
        }

        this.$gtm.trackEvent({
          event: 'GAEvent',
          eventCategory: 'Onboarding - Seller Account UI',
          eventAction: 'InvisibleRecaptcha Retry',
          eventLabel: '',
        });
        this.injectScript(true);
      };

      return document.head.appendChild(script);
    },
  },

  computed: {
    recaptchaId () {
      return 'vue-invisible-recaptcha-' + this.id;
    },
  },

  mounted () {
    window.onloadCallback = () => {
      this.render();
    };

    if (typeof window.grecaptcha === 'undefined') {
      return this.injectScript();
    }

    return this.render();
  },
};
</script>
<style lang="scss">
  .grecaptcha-badge {
    visibility: hidden;
  }
  .invisible-captcha-btn {
    .g-spinner div {
      border-color: white transparent transparent transparent !important;
    }

    .g-spinner.-small {
      padding: unset !important;
    }
  }

</style>
